export default __webpack_public_path__ + "static/media/ic_image.beb436e0.png";